import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "EventSchedule"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 5.25C21 4.42157 20.3284 3.75 19.5 3.75H16.5V2.25H15V3.75H9V2.25H7.5V3.75H4.5C3.67157 3.75 3 4.42157 3 5.25V20.25C3 21.0784 3.67157 21.75 4.5 21.75H7.5V20.25H4.5V5.25H7.5V6.75H9V5.25H15V6.75H16.5V5.25H19.5V9.75H21V5.25ZM9.75 16.5C9.75 19.8137 12.4363 22.5 15.75 22.5C19.0637 22.5 21.75 19.8137 21.75 16.5C21.75 13.1863 19.0637 10.5 15.75 10.5C12.4363 10.5 9.75 13.1863 9.75 16.5ZM15 17.5575L16.9425 19.5L18 18.4425L16.5 16.9425V14.25H15V17.5575ZM11.25 16.5C11.25 14.0147 13.2647 12 15.75 12C18.2353 12 20.25 14.0147 20.25 16.5C20.25 18.9853 18.2353 21 15.75 21C13.2647 21 11.25 18.9853 11.25 16.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/EventSchedule.vue"]]);
